import attributeIds from './attributeIds';
import _ from 'underscore';
import GeoFire from 'geofire';

class GeoFireReporter {

    constructor(geoFire, report, location, onReportFinished) {
        this.geoFire = geoFire;
        this.report = report;
        this.location = location;
        this.radiusIndex = 0;
        this.radiusOptions = [50, 30, 10, 5];
        this.queries = 0;
        this.queriesByRadius = {};
        this.onReportFinished = onReportFinished;
    }

    convertToKM(radiusInMiles) {
        if (radiusInMiles) {
            return radiusInMiles * 1.60934;
        }
    }

    getRadius() {
        return this.radiusOptions[this.radiusIndex];
    }

    query() {
        this.geoQuery = this.geoFire.query({
            center: [
                this.location.latitude, this.location.longitude
            ],
            radius: this.convertToKM(this.getRadius())
        });
        this.geoQuery.on("key_entered", (key) => {
            this.queries++;
            this.setTimeout();
        });
        this.geoQuery.on("key_exited", (key) => {
            this.queries--;
            this.setTimeout();
        });
        this.setTimeout();
    }

    updateQuery() {
        const criteria = {};
        criteria.radius = this.convertToKM(this.getRadius());
        this.geoQuery.updateCriteria(criteria);
    }

    setTimeout() {
        if (this.timeout) {
            window.clearTimeout(this.timeout);
        }
        this.timeout = window.setTimeout(() => {
            this.queriesByRadius[this.getRadius()] = this.queries;
            if (this.queries && this.radiusIndex < this.radiusOptions.length - 1) {
                this.radiusIndex++;
                this.updateQuery();
                this.setTimeout();
            } else {
                // console.log('bailing for', this.location.name, this.getRadius(), this.queries);
                this.report.queriesByRadius = this.queriesByRadius;
                this.geoQuery.cancel();
                if (this.onReportFinished) {
                    this.onReportFinished(this.report);
                }
            }
        }, 500);
    }

}

class ReportsGenerator {

    constructor(firebase) {
        this.firebase = firebase;
        this.geoFire = new GeoFire(firebase.database().ref('/reports/geoFire'));
    }

    generateReports() {
        const queries = [];
        const specialtyFilters = {};
        let specialtyAttribute = null;
        this.reportKey = this.firebase.database().ref(`/reports/generated`).push({ start: new Date().toString() }).key;
        this.numLocations = 0;

        this.fetchSpecialtyAttribute().then(snapshot => {
            specialtyAttribute = snapshot.val();
        }).then(() => {
            this.fetchQueries().then(queriesSnapshot => {
                queriesSnapshot.forEach(childSnapshot => {
                    const query = childSnapshot.val();
                    this.geoFire.set(childSnapshot.key, [query.lat, query.lng]);
                    queries.push(query);
                });
            });
        }).then(() => {
            this.fetchSpecialties().then(specialtiesSnapshot => {
                specialtiesSnapshot.forEach(childSnapshot => {
                    specialtyFilters[childSnapshot.key] = Object.keys(childSnapshot.val()).length;
                });
            });
        }).then(() => {
            this.fetchLocations().then(snapshot => {
                snapshot.forEach(childSnapshot => {
                    // kbm - only generate a report if the location has an email address
                    // TODO: I think we are going to change the field, need to talk to NICA
                    if (childSnapshot.val().emailAddress) {
                        this.numLocations++;
                        const key = childSnapshot.key;
                        const location = childSnapshot.val();
                        const locationSpecialties = location.attributes[attributeIds.practiceSpecialty];

                        const report = {
                            locationName: location.name,
                            address1: location.address1,
                            city: location.city,
                            stateAbbr: location.stateAbbr,
                            postCode: location.postCode,
                            totalSearches: queries.length,
                            specialtySearches: [],
                            email: location.emailAddress,
                            claimed: !!location.orgId
                        };

                        if (locationSpecialties && locationSpecialties.choice) {
                            locationSpecialties.choice.forEach(choice => {
                                report.specialtySearches.push({
                                    specialty: specialtyAttribute.options[choice].name,
                                    count: specialtyFilters[choice] ? specialtyFilters[choice] : 0
                                });
                            });
                        }

                        this.fetchLocationReportData(key).then(snapshot => {
                            const data = snapshot.val();
                            let websiteClicks = 0;
                            let contacts = 0;
                            let phoneClicks = 0;
                            let visits = 0;
                            let directionsClicks= 0;
                            if (data) {
                                if (data.website_clicks) {
                                    websiteClicks = Object.keys(data.website_clicks).length;
                                }
                                if (data.contact_emails) {
                                    contacts = Object.keys(data.contact_emails).length;
                                }
                                if (data.phone_clicks) {
                                    phoneClicks = Object.keys(data.phone_clicks).length;
                                }
                                if (data.visits) {
                                    visits = Object.keys(data.visits).length;
                                }
                                if (data.directions_clicks) {
                                    directionsClicks = Object.keys(data.directions_clicks).length;
                                }
                            }
                            _.extend(report, { websiteClicks, contacts, phoneClicks, visits, directionsClicks });
                            new GeoFireReporter(this.geoFire, report, location, this.onReportFinished).query();
                        });
                    }
                });
            });
        });
    }

    onReportFinished = (report) => {
        this.firebase.database().ref(`reports/generated/${this.reportKey}/locationReports`).push(report);
        this.numLocations--;
        if (this.numLocations === 0) {
            this.firebase.database().ref(`reports/generated/${this.reportKey}`).update({ end: new Date().toString() });
            this.cleanup();
        }
    }

    cleanup() {
        this.firebase.database().ref('reports/geoFire').remove();
        // TODO: delete the old report data
    }

    fetchSpecialtyAttribute() {
        return this.firebase.database().ref(`attributes/${attributeIds.practiceSpecialty}`).once('value');
    }

    fetchQueries() {
        return this.firebase.database().ref('reports/searches/queries').once('value');
    }

    fetchSpecialties() {
        return this.firebase.database().ref('reports/searches/filters/specialty').once('value');
    }

    fetchLocations() {
        return this.firebase.database().ref('locations').once('value');
    }

    fetchLocationReportData(locationId) {
        return this.firebase.database().ref(`reports/locations/${locationId}`).once('value');
    }

}

export default ReportsGenerator;


// WEBPACK FOOTER //
// ./src/api/ReportsGenerator.js